import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BondRequestModel, BondRequestUpdateModel } from '@data-layer/models/common';

/**
 * Customs-broker bond-request endpoints (#13102). Mirrors the user-side BondRequestRepository but on
 * the management/customs-broker prefix; the create endpoint is scoped to the ES (companyId inferred
 * server-side from the entry summary, not the active company). There is no broker PUT (update) — a
 * CREATED request is replaced by delete + create (see BrokerEsStateService.createOrUpdateBondRequest).
 */
@Injectable({
  providedIn: 'root',
})
export class BondRequestsCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  public create(entrySummaryId: number, bondRequest: BondRequestUpdateModel, isShowLoader: boolean = true): Observable<BondRequestModel> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/customs-broker/entry-summaries/${entrySummaryId}/bond-requests`,
      bondRequest,
      undefined,
      { isShowLoader },
    );
  }

  public delete(bondRequestId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/bond-requests/${bondRequestId}`, null, {
      isShowLoader,
    });
  }
}
